export const HOUSEHOLD_INCOME_COMPARISON = {
    higher: {
        en: 'Higher than the year before',
        es: 'Más altos que el año anterior'
    },
    lower: {
        en: 'Lower than the year before',
        es: 'Más bajos que el año anterior'
    },
    same: {
        en: 'About the same as the year before',
        es: 'Más o menos igual que el año anterior'
    },
    idk: {
        en: "Don't Know",
        es: 'No sé'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
